





















































































import {Component, Prop, Vue} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import {PartnerStore} from "@/modules/partners/store";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import { PartnerType } from "@/enums/type";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {CommonStatus} from "@/enums/status";
import {PHONE_REGEX} from "@/shared/constant";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";
import ATextareaCustom from "@/shared/components/TextAreaAntCustom/index.vue";

const form = {
    rowGuid: undefined,
    code: "",
    name: "",
    phoneNumber: "",
    address: "",
    type: undefined,
    note: "",
    status: undefined,
    postOfficeRowGuid: undefined
};
@Component({
    name: "PartnerForm",
    components: {ATextareaCustom, AInputCustom, PostOfficeSelector, EnumSelector},
})
export default class extends mixins(CommonMixin) {
    @Prop()
    readonly id!: string;

    PartnerType = PartnerType;
    CommonStatus = CommonStatus;
    private form = {...form};

    private rules = {
        code: [{ required: true, message: "Nhập mã đối tác", trigger: "change" }],
        name: [{ required: true, message: "Nhập tên đối tác", trigger: "change" }],
        phoneNumber: [
            { required: true, message: "Nhập sđt đối tác", trigger: "change" },
            { pattern: new RegExp(PHONE_REGEX), message: "Số điện thoại không đúng định dạng", trigger: "change" }
        ],
        address: [{ required: true, message: "Nhập địa chỉ đối tác", trigger: "change" }],
        note: [{ required: false }],
        type: [{ required: true, message: "Chọn loại đối tác", trigger: "change" }],
        status: [{ required: false }],
        postOfficeRowGuid: [{ required: false }],
    };

    private onSubmit() {
        (this.$refs.formPartner as FormModel).validate(async valid => {
            if (!valid) return;
            try {
                this.id
                    ? await PartnerStore.updatePartner(this.form)
                    : await PartnerStore.createPartner(this.form);
                this.$notification.success({
                    message: "Thành công",
                    description: `${this.id ? 'Sửa' : 'Tạo'} đối tác thành công`
                });
                this.$router.push({ name: "listPartner" });
            } catch (e) {
                this.$message.error({
                    content: `${e.response?.data?.message || `${this.id ? 'Sửa' : 'Tạo'} đối tác thất bại`}`
                })
            }
        })
    }

    async created() {
        if (this.id) {
            try {
                const data = await PartnerStore.singlePartner(this.id);
                this.form = assignValueToForm(this.form, data);
            } catch (e) {
                this.$message.error({
                    content: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
                })
            }
        }
    }
}
